
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Web-Elements/BackToTop.html",
      function () {
        return require("private-next-pages/Web-Elements/BackToTop.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Web-Elements/BackToTop.html"])
      });
    }
  